import React from 'react'
import { RecoilRoot } from 'recoil'
import GoTop from './GoTop'
import {Link} from 'gatsby'
import Helmet from 'react-helmet'
import CookieConsent from 'react-cookie-consent'
import { isWindows } from 'react-device-detect'
import ReferrerAnalytics from '../../components/Analytics/ReferrerAnalytics'


const Layout = ({ children, env }) => {
    
    return (
        <RecoilRoot>
            <CookieConsent
                location="bottom"
                buttonText="Okay, thanks"
                cookieName="bluemailCookie"
                style={{ background: '#2B373B', fontSize: '15px' }}
                buttonStyle={{
                color: 'white',
                background: '#0B71BC',
                fontSize: '13px',
                margin: '0 100px 0 0',
                cursor: 'pointer',
                }}
            >
                This site uses cookies to assist with navigation and your ability to
                provide feedback, analyze your use of our products and services{' '}
                <Link style={{ fontWeight: '600', color: '#1F6BF1' }} to="/cookie-policy/">
                Find out more.
                </Link>
            </CookieConsent>
            <Helmet>
                <link rel="icon" type="image/png" href="/img/mini-logo.webp" />
                {env && env === 'staging' && <meta name="robots" content="noindex" />}
            </Helmet>
            {children}
            <GoTop scrollStepInPx="100" delayInMs="10.50" />
        </RecoilRoot>
    )
}

export default Layout
